export const TODAY = 0;
export const YESTERDAY = 1;
export const LAST_SEVEN_DAY = 7;
export const LAST_THIRTY_DAY = 30;
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_INDEX = 1;

export const DEFAULT_PAGINATION = {
  pageIndex: 1,
  pageSize: 20,
};
